<template>
    <div class="text-center">
        <v-dialog
            v-model="visible"
            @click:outside="$emit('on-no')"
            max-width="400">
            <v-card>
                <v-card-title class="text-h5">{{ title }}</v-card-title>
                <v-card-text class="pb-3">
                    <p class="text--black text-body-1 mb-0">{{ message }}</p>
                </v-card-text>
                <v-card-actions class="px-2">
                    <v-spacer></v-spacer>
                    <v-btn depressed @click="$emit('on-no')">{{ no }}</v-btn>
                    <v-btn depressed color="error" @click="$emit('on-yes')">{{ yes }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
export default {
    name: 'SimpleDialog',
    props: {
        visible: {
            type: Boolean,
            required: true
        },
        title: {
            type: String
        },
        message: {
            type: String
        },
        no: {
            type: String,
            default: 'No'
        },
        yes: {
            type: String,
            default: 'Yes'
        }
    }
}
</script>
